import { useTheme } from '@mui/material'
import { PieChartComponent } from '../../../common/components/PieChartComponent/PieChartComponent'
import { useStyles } from '../RevenueByProductChart/RevenueByProductChart.styles'
import React from 'react'
import { PieCustomTooltip } from '../RevenueByProductChart/PieCustomTooltip/PieCustomTooltip'
import { PaletteColor } from '@mui/material'
import { CustomLegends } from '../CustomLegends/CustomLegends'

export type PieDataInfo = {
  id: string
  label: string
  color: PaletteColor
  value: number
  cloud: string
  percentage?: number
}

export const AccepetedOfferBySales = () => {
  const { classes } = useStyles()
  const theme = useTheme()
  const datapie = [
    {
      id: 'Szekeres Dalma',
      label: 'Szekeres Dalma',
      color: theme.palette.awsGraph,
      value: 11,
    },
    {
      id: 'Halász Emese',
      label: 'Halász Emese',
      color: theme.palette.awsGraph,
      value: 19,
    },
    {
      id: 'Katona Beatrix',
      label: 'Katona Beatrix',
      color: theme.palette.awsGraph,
      value: 26,
    },
    {
      id: 'Other',
      label: 'Other',
      color: theme.palette.awsGraph,
      value: 35,
    },
  ]
  const otherProducts = [
    {
      id: 'Jhone Doi',
      label: 'Jhone Doi',
      color: theme.palette.awsGraph,
      value: 6,
    },
    {
      id: 'Allen Damin',
      label: 'Allen Damin',
      color: theme.palette.awsGraph,
      value: 22,
    },
    {
      id: 'Rachel Samlin',
      label: 'Rachel Samlin',
      color: theme.palette.awsGraph,
      value: 11,
    },
  ]
  return (
    <div
      className={classes.responsivePieWrapper}
      data-testid={'accepeted-offer-by-sales-chart'}
    >
      <div className={classes.leftContainer} data-testid={'pie-container'}>
        <PieChartComponent
          data={datapie}
          height="184px"
          width="176px"
          colors={[
            theme.palette.awsGraph.main,
            theme.palette.gcpGraph.main,
            theme.palette.microsoftGraph.main,
            theme.palette.otherGraph.main,
          ]}
          tooltipContent={point => (
            <PieCustomTooltip otherProducts={otherProducts} point={point} />
          )}
        />
      </div>
      <div className={classes.rightContainer} data-testid={'legend-container'}>
        <CustomLegends
          flexDirection="column"
          legends={[
            {
              label: 'Szekeres Dalma',
              legendColor: theme.palette.awsGraph.main,
              legendSize: 'medium',
              value: '22',
              isKeyValue: true,
            },
            {
              label: 'Allen Damin',
              legendColor: theme.palette.gcpGraph.main,
              legendSize: 'medium',
              value: '3',
              isKeyValue: true,
            },
            {
              label: 'Katona Beatrix',
              legendColor: theme.palette.microsoftGraph.main,
              legendSize: 'medium',
              value: '23',
              isKeyValue: true,
            },
            {
              label: 'Other',
              legendColor: theme.palette.microsoftGraph.main,
              legendSize: 'medium',
              value: '45',
              isKeyValue: true,
            },
          ]}
        />
      </div>
    </div>
  )
}
